<!--选择城市-->
<template>
  <div class="header-banner" v-if="swiperList.length > 0">
    <div class="swiper-box">
      <pi-swipe :list="swiperList"></pi-swipe>
    </div>
  </div>
</template>

<script>
import HomeSearchResult from "@/components/pi-swipe/pi-swipe";
import { getSystemnotice } from "@/common/api";
export default {
  name: "pi-header-banner",
  props: {},
  components: {
    [HomeSearchResult.name]: HomeSearchResult,
  },
  data() {
    return {
      swiperList: [],
    };
  },
  activated() {
    this.getSystemnotice();
  },
  methods: {
    async swipclick(item) {
      if (item.campaignType != 4 && item.campaignPkId) {
        this.$router.push(
          "/activity-details?campaignPkId=" +
            item.campaignPkId +
            "&campaignType=" +
            item.campaignType
        );
      }
    },
    async getSystemnotice() {
      let ret = await getSystemnotice({}, { loading: false });
      if (ret.status === 0) {
        var data = ret.data || [];
        // data.map((item) => {
        //   if (item.url) {
        //     item.url = getFilePath(item.url);
        //   }
        // });
        this.swiperList = data;
      }
      this.$emit("loadingsuccess", this.swiperList);
    },
  },
};
</script>

<style lang="less" scoped>
.header-banner {
  padding: 0 0.2rem 0.2rem 0.2rem;
  background-color: #fff;
  .swiper-box {
    height: 1.5rem;
    width: 100%;
  }
}
</style>
